import { defaultContextValues, IAction, IState } from './useNewSftpUserContext';

export type ActionTypes =
  | 'CLEAR_ERROR'
  | 'CREATE_SFTP_USER_SUCCESS'
  | 'CREATE_SFTP_USER_FAIL'
  | 'RESET_WIZARD'
  | 'UPDATE_SITES'
  | 'UPDATE_BRANDS'
  | 'UPDATE_GROUPS'
  | 'UPDATE_STEP_VALID'
  | 'UPDATE_SFTP_USER_EMAIL'
  | 'UPDATE_SFTP_USER_NAME'
  | 'UPDATE_VALID_STEPS';

const getNextUserState = (state: IState, type: string, clients) => ({
  ...state,
  sftpUser: {
    ...state.sftpUser,
    [type]: clients,
  },
});

export function newSftpUserReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'CREATE_SFTP_USER_FAIL':
    case 'CREATE_SFTP_USER_SUCCESS':
      newState = {
        ...state,
        success: payload.success,
        createdSftpUser: payload.createdSftpUser,
        error: payload.error,
        errorMessage: payload.errorMessage,
      };
      break;
    case 'RESET_WIZARD':
      newState = { ...defaultContextValues };
      break;
    case 'CLEAR_ERROR':
      newState = {
        ...state,
        error: false,
      };
      break;
    case 'UPDATE_SITES':
      newState = getNextUserState(state, 'sites', payload.sites);
      break;
    case 'UPDATE_GROUPS':
      newState = getNextUserState(state, 'groups', payload.groups);
      break;
    case 'UPDATE_BRANDS':
      newState = getNextUserState(state, 'brands', payload.brands);
      break;
    case 'UPDATE_SFTP_USER_NAME':
      newState = {
        ...state,
        sftpUser: {
          ...state.sftpUser,
          username: payload.username,
        },
      };
      break;

    case 'UPDATE_SFTP_USER_EMAIL':
      newState = {
        ...state,
        sftpUser: {
          ...state.sftpUser,
          email: payload.email,
        },
      };
      break;

    case 'UPDATE_STEP_VALID':
      newState = {
        ...state,
        stepValid: payload.stepValid,
      };
      break;

    case 'UPDATE_VALID_STEPS':
      newState = {
        ...state,
        validSteps: payload.validSteps,
      };
      break;

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }

  return newState;
}
